var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "curentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.3308C4 12.745 4.33579 13.0808 4.75 13.0808L17.9393 13.0808L12.4697 18.5505C12.1768 18.8434 12.1768 19.3182 12.4697 19.6111C12.7626 19.904 13.2374 19.904 13.5303 19.6111L20.2803 12.8611C20.5732 12.5682 20.5732 12.0934 20.2803 11.8005L13.5303 5.05048C13.2374 4.75759 12.7626 4.75759 12.4697 5.05048C12.1768 5.34337 12.1768 5.81825 12.4697 6.11114L17.9393 11.5808L4.75 11.5808C4.33579 11.5808 4 11.9166 4 12.3308Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6d6c78c511d15fd91ffab078fcca73bb.svg";
export { ForwardRef as ReactComponent };